module.exports = __webpack_public_path__ + "static/img/hr3.2e6aee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr3.jpg
// module id = hz8e
// module chunks = 0